"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _a, _b, _c;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utilities_1 = require("@dynamynd/utilities");

var React = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var ButtonIconPosition_enum_1 = require("./ButtonIconPosition.enum");

var ButtonSize_enum_1 = require("./ButtonSize.enum");

var ButtonType_enum_1 = require("./ButtonType.enum");

var ButtonColorKeysEnum;

(function (ButtonColorKeysEnum) {
  ButtonColorKeysEnum["container"] = "container";
  ButtonColorKeysEnum["inner"] = "inner";
})(ButtonColorKeysEnum || (ButtonColorKeysEnum = {})); // todo nest another object


var colors = (_a = {}, _a[ButtonColorKeysEnum.container] = (_b = {}, _b[ButtonType_enum_1.ButtonTypeEnum.primary] = 'colorVariations.purple.alpha20', _b[ButtonType_enum_1.ButtonTypeEnum.secondary] = 'colorVariations.orange.alpha20', _b), _a[ButtonColorKeysEnum.inner] = (_c = {}, _c[ButtonType_enum_1.ButtonTypeEnum.primary] = 'colors.main.purple', _c[ButtonType_enum_1.ButtonTypeEnum.secondary] = 'colors.secondary.orange', _c), _a); // todo font should come from the theme

exports.StyledLinkText = styled_components_1.default(function (_a) {
  var customColor = _a.customColor,
      uppercase = _a.uppercase,
      theme = _a.theme,
      rest = __rest(_a, ["customColor", "uppercase", "theme"]);

  return React.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    text-transform: ", ";\n    font-family: Roboto;\n    font-weight: bold;\n"], ["\n    color: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n    text-transform: ", ";\n    font-family: Roboto;\n    font-weight: bold;\n"])), function (props) {
  return props.customColor ? props.customColor : props.theme.colors.main.purple;
}, function (props) {
  return props.theme.typography.button.fontSize;
}, function (props) {
  return props.theme.typography.button.lineHeight;
}, function (_a) {
  var uppercase = _a.uppercase;
  return uppercase ? 'uppercase' : 'none';
});
exports.ButtonOuterContainer = styled_components_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    transform: rotate(5deg);\n    margin: 0 20px;\n    border-radius: 28px;\n    background-color: ", ";\n    opacity: ", ";\n"], ["\n    transform: rotate(5deg);\n    margin: 0 20px;\n    border-radius: 28px;\n    background-color: ", ";\n    opacity: ", ";\n"])), function (props) {
  return setBackground(props, ButtonColorKeysEnum.container);
}, function (props) {
  return props.disabled ? 0.5 : 1;
});
exports.ButtonContainer = styled_components_1.default(function (_a) {
  var size = _a.size,
      rest = __rest(_a, ["size"]);

  return React.createElement(react_native_1.TouchableWithoutFeedback, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    transform: rotate(-5deg);\n    padding: ", ";\n    border-radius: 28px;\n    background-color: ", ";\n    opacity: ", ";\n"], ["\n    transform: rotate(-5deg);\n    padding: ", ";\n    border-radius: 28px;\n    background-color: ", ";\n    opacity: ", ";\n"])), function (_a) {
  var size = _a.size;
  return size === ButtonSize_enum_1.ButtonSizeEnum.small ? '0 12px' : '12px 32px';
}, function (props) {
  return setBackground(props, ButtonColorKeysEnum.inner);
}, function (props) {
  return props.disabled ? 0.5 : 1;
});

function setBackground(props, key) {
  var type = props.type,
      theme = props.theme;
  var activeType = type === ButtonType_enum_1.ButtonTypeEnum.primary ? ButtonType_enum_1.ButtonTypeEnum.primary : ButtonType_enum_1.ButtonTypeEnum.secondary;
  return utilities_1.get(theme, colors[key][activeType]);
}

exports.ButtonText = styled_components_1.default(function (_a) {
  var customColor = _a.customColor,
      uppercase = _a.uppercase,
      rest = __rest(_a, ["customColor", "uppercase"]);

  return React.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", "px;\n    text-transform: ", ";\n    line-height: ", "px;\n"], ["\n    color: ", ";\n    font-size: ", "px;\n    text-transform: ", ";\n    line-height: ", "px;\n"])), function (props) {
  return props.customColor ? props.customColor : props.theme.colors.white;
}, function (props) {
  return props.theme.typography.button.fontSize;
}, function (_a) {
  var uppercase = _a.uppercase;
  return uppercase ? 'uppercase' : 'none';
}, function (props) {
  return props.theme.typography.button.lineHeight;
});
exports.ImageIcon = styled_components_1.default(react_native_1.Image)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 14px;\n    height: 16px;\n    vertical-align: sub;\n    margin-left: 15px;\n"], ["\n    width: 14px;\n    height: 16px;\n    vertical-align: sub;\n    margin-left: 15px;\n"])));
exports.IconContainer = styled_components_1.default(function (_a) {
  var position = _a.position,
      rest = __rest(_a, ["position"]);

  return React.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-left: ", ";\n    margin-right: ", ";\n"], ["\n    margin-left: ", ";\n    margin-right: ", ";\n"])), function (props) {
  return props.position === ButtonIconPosition_enum_1.ButtonIconPositionEnum.right ? '10px' : '0';
}, function (props) {
  return props.position === ButtonIconPosition_enum_1.ButtonIconPositionEnum.left ? '10px' : '0';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;